export const FEEDBACK_LOOKUPS: { [key: string]: string } = {
    hrConsultantLookup: 'api/ProjectLookups/HRConsultantLookup',
    projectLookup: 'api/ProjectLookups/ProjectLookup',
    monthlyRetainedOptionLookup: 'api/MasterLookups/MonthlyRetainedOptionLookup'
}